export default __webpack_public_path__ + "static/media/triangle_shape.36de00a4.svg";